import  store from '../store'

/**
 *
 * 根据平台创建相关sdk
 * @export
 */
export function createPlatFormScript () {
  // 如果是qq小程序
  let app = document.querySelector('#app')
  let script = document.createElement('script')
  const platform = store.state.userInfo.platform
  script.type = 'text/javascript'
  script.src = '//qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js'
  if (platform === 'TENCENT_QQ_VEHICLE') {
    script.src = '//qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js'
  } else if (platform === 'TENCENT_BYTE_DANCE_VEHICLE') {
    script.src = '//s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js'
  } else {
    script.src = '//res.wx.qq.com/open/js/jweixin-1.4.0.js'
  }
  app.appendChild(script)
}